import { APIData } from "./APIData"
import { Constants } from "./constants"

export class ErrorData {
  api: number
  errorJson: any
  sites: any
  errorCode: number
  refCode: any = 0
  apiToCall: number
  _errorMsg: string = Constants.COMMON_ERR_MSG
  apiData: APIData
  isFullScreen: boolean = false
  additionalData: any[]

  public get errorMsg(): string {
    if (this._errorMsg == undefined || this._errorMsg == '') {
      return Constants.COMMON_ERR_MSG
    } else {
      return this._errorMsg
    }
  }

  public set errorMsg(errMsg: string) {
    this._errorMsg = errMsg;
  }
}
